module.exports = __webpack_public_path__ + "static/fanta-4-0fcd587a7bebb6aed7c2798f269a249c.jpg";